import React from 'react';
import PropTypes from 'prop-types';
import { APP_NOTIFICATION_TIMEOUT } from '../../config/app_config';

export default class SuccessBox extends React.Component {
  static propTypes = {
    success: PropTypes.object.isRequired,
    dismissSuccessFunction: PropTypes.func,
  };

  static defaultProps = {
    dismissSuccessFunction: null,
  };

  // Close the notification automatically after a set period of time
  componentWillMount = () => {
    const { dismissSuccessFunction } = this.props;
    this.clockTimeout = setTimeout(() => {
      dismissSuccessFunction();
    }, APP_NOTIFICATION_TIMEOUT);
  };

  componentWillUnmount = () => {
    if (this.clockTimeout) {
      clearTimeout(this.clockTimeout);
    }
  };

  clockTimeout = null;

  render() {
    const { success, dismissSuccessFunction } = this.props;
    return (
      <div className="row">
        <div className="col-xs-12">
          <div className="alert alert-success alert-dismissible fade in" role="alert">
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={dismissSuccessFunction}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            {success && success.text ? (
              <p className="message">
                <i className="fa fa-check" aria-hidden="true" /> {success.text}
              </p>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
